import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { handleApiResponse } from '@src/api/apiClient/axiosClient.ts';
import { inAppNotificationApiClient } from '@src/api/company/inAppNotification/inAppNotificationApiClient.ts';
import {
  InAppNotification,
  InAppNotificationIndexResponse,
} from '@src/api/types/inAppNotification.ts';

interface CompanyInAppNotificationState {
  notifications: InAppNotification[];
  latestCreatedAt: string | null;
}

const initialState: CompanyInAppNotificationState = {
  notifications: [],
  latestCreatedAt: null,
};

export const fetchNotifications = createAsyncThunk('companyInAppNotification/fetch', async () => {
  const res = await inAppNotificationApiClient.index();
  let result = { notifications: [], latest_created_at: '' } as InAppNotificationIndexResponse;
  handleApiResponse(res, (data) => {
    result = data;
  });
  return result;
});

const companyInAppNotificationSlice = createSlice({
  name: 'companyInAppNotification',
  initialState,
  reducers: {
    setNotifications: (state, action: PayloadAction<InAppNotificationIndexResponse>) => {
      state.notifications = action.payload.notifications;
      state.latestCreatedAt = action.payload.latest_created_at;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchNotifications.fulfilled, (state, action) => {
      state.notifications = action.payload.notifications;
      state.latestCreatedAt = action.payload.latest_created_at;
    });
  },
});

export const { setNotifications } = companyInAppNotificationSlice.actions;
export default companyInAppNotificationSlice.reducer;
